import { React, useEffect } from 'react';

const DonorBox = () => {
  /* This approach allows the donor box iFrame to expand its height dynamically */
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://donorbox.org/widget.js';
    script.setAttribute('paypalExpress', 'false');
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <iframe
      title="Support GLOS"
      // src="https://donorbox.org/embed/support-great-lakes-monitoring-and-protection?"
      // src="https://donorbox.org/embed/support-seagull-campaign?"
      src="https://donorbox.org/embed/donate-glos?"
      name="donorbox"
      // eslint-disable-next-line react/no-unknown-property
      allowpaymentrequest="true"
      seamless="true"
      frameBorder="0"
      scrolling="no"
      width="100%"
      style={{
        maxWidth: '400px',
        minWidth: '250px',
      }}
      allow="payment"
    />
  );
};

DonorBox.propTypes = {
};

DonorBox.defaultProps = {
};

export default DonorBox;
